export const colors = {
  // old colors
  backgroundPrimary: '#ffffff',
  backgroundSecondary: '#000000',
  backgroundTertiary: '#E7EEF3',
  backgroundContainer: '#F3F3F3',
  primaryMain: '#000000',
  primary50: '#808080',
  primary30: '#B3B3B3',
  primary20: '#CCCCCC',
  primary5: '#F1F1F1',
  textPrimary: '#000000',
  textPrimary50: 'rgba(0, 0, 0, 0.5)',
  textPrimary60: 'rgba(0, 0, 0, 0.6)',
  textPrimary30: '#B3B3B3',
  textPrimary20: '#CCCCCC',
  textPrimary12: 'rgba(0, 0, 0, 0.12)',
  uiRed: '#FF3A44',
  uiGreen: '#15CF74',
  uiYellow: '#FFD600',
  uiRed10: '#FFEBEC',
  uiYellow10: '#FFFBE6',
  uiGreen10: '#E8FAF1',
  uiYellow20: '#FFF7CC',
  uiGrey: '#CCDBE6',
  uiGrey10: 'rgba(204, 219, 230, 0.3)',
  disabledInputBackgroundFormIo: '#e9ecef',
  backgroundLoader: 'rgba(255, 255, 255, 0.8)',
  backgroundLoaderRotatableUnit: '#2ec0c1',
};

// old gradients
export const gradients = {
  primary: 'linear-gradient(68.94deg, #C3AAB2 -4.77%, #99EECC 46.72%, #80C0C8 90.23%, #4B8BFA 134.46%)',
  secondary: 'linear-gradient(87.99deg, #C3AAB2 0.66%, #99EECC 57.2%, #80C0C8 75.87%, #4B8BFA 98.72%)',
  radial: [
    'radial-gradient(',
    '92.76% 76.25% at 7.24% 21%, #B5D39D 0%, #F1ACAC 25.66%, #BF98C6 54.47%, #7179EF 86.04%, #2833D0 100%',
    ') 1'].join(''),
};

export const shadows = {
  primary: '0px 3px 5px rgba(0, 0, 0, 0.2)',
  notification: '0px 3px 8px rgba(0, 0, 0, 0.33)',
};

export const spacing = 8;
